import React, { useEffect, useRef, useState } from "react";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import { FileEarmarkFill, Trash3 } from "react-bootstrap-icons";
import Select from "react-select";
import "./people.scss";
import DownloadExcel from "../Download_Excel/download_Excel";
import { Modal } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import {
  customStyles,
  customSingleSelectStyles,
} from "../../utils/constants/CustomStyles.constants";
import formatDate from "../../utils/helpers/formatDate";
import * as XLSX from "xlsx";
import { format } from "date-fns";

interface People {
  login_device: any;
  device: string;
  name: string;
  id: number;
  first_name: string;
  last_name: string;
  dob: string;
  city: string;
  emp_code: string;
  os_version: string;
  app_version: string;
  is_Godmod: 0 | 1;
  designation: string;
  email: string;
  mobileNo: string;
  status: number;
  modified: string;
  created: string;
  last_app_sync_time: string;
  loginAt: string;
  logout_time: string;
  is_login: 0 | 1 | number;
  Close_Date: string;
}

const sortingOptions = [
  { value: "az", label: "A-Z" },
  { value: "za", label: "Z-A" },
  { value: "loggedIn", label: "Logged In Users" },
  { value: "notLoggedIn", label: "Not Logged In Users" },
];

const PeopleTable = ({
  isPeopleDataFetched,
}: {
  isPeopleDataFetched: boolean;
}) => {
  const navigate = useNavigate();
  const cmpMounted = useRef(false);
  const dispatch = useAppDispatch();
  // const downloadExcelRef = useRef<any>(null);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [allPeople, setAllPeople] = useState<People[]>([]);
  const [people, setPeople] = useState<People[]>([]);
  const [sortingOption, setSortingOption] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // if (cmpMounted.current === true) return;
    // cmpMounted.current = true;
    fetchPeople();
  }, [isPeopleDataFetched]);

  const fetchPeople = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_ALL_PEOPLE, {});
      // console.log(response);
      const sortedItems = sortByModified(response.data);
      // console.log("SORTED PEOPLE",sortedItems)
      setPeople(sortedItems);
      setAllPeople(sortedItems);
    } catch (error) {
      console.log("Error fetching people", error);
      dispatch(showToast("Error fetching people details"));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const sortByModified = (people: People[]): People[] => {
    return people.slice().sort((a, b) => {
      return new Date(b.modified).getTime() - new Date(a.modified).getTime();
    });
  };

  const fetchLoggedInUsers = async (): Promise<People[]> => {
    try {
      dispatch(showLoader("Loading data..."));
      //  const response = await postDetails(APIList.GET_ALL_PEOPLE, {sortBy: "login"});
      //  return response.data;
      const response = allPeople.filter((person) => person.is_login === 1);
      return response;
    } catch (error) {
      console.error("Error fetching logged in users:", error);
      dispatch(showToast("Failed to fetch logged in users"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return [];
    } finally {
      dispatch(hideLoader());
    }
  };

  const fetchNotLoggedInUsers = async (): Promise<People[]> => {
    try {
      dispatch(showLoader("Loading data..."));
      //  const response = await postDetails(APIList.GET_ALL_PEOPLE, {sortBy: "logout"});
      //  return response.data;
      const response = allPeople.filter((person) => person.is_login === 0);
      return response;
    } catch (error) {
      console.error("Error fetching not logged in users:", error);
      dispatch(showToast("Failed to fetch not logged in users"));
      setTimeout(() => dispatch(hideToast()), 3000);
      return [];
    } finally {
      dispatch(hideLoader());
    }
  };

  function sortPeople(people: People[], sortOption: string): People[] {
    switch (sortOption) {
      case "az":
        return [...people].sort((a, b) =>
          a.first_name.localeCompare(b.first_name)
        );
      case "za":
        return [...people].sort((a, b) =>
          b.first_name.localeCompare(a.first_name)
        );
      // case 'loggedIn':
      //   return [...people].sort((a, b) =>
      //     b.is_login - a.is_login
      //   );
      // case 'notLoggedIn':
      //   return [...people].sort((a, b) =>
      //     a.is_login - b.is_login
      //   );
      default:
        return people;
    }
  }

  const sortPeopleOption = async (option: any) => {
    setSortingOption(option);
    // console.log(option)
    let sortedPeople: People[];
    // if(option === null) {
    //   sortedPeople = sortByModified(people)
    // }
    // else{
    //   sortedPeople = sortPeople(people, option.value)
    // }

    if (option === null) {
      sortedPeople = sortByModified(allPeople);
    } else if (option.value === "loggedIn") {
      sortedPeople = await fetchLoggedInUsers();
    } else if (option.value === "notLoggedIn") {
      sortedPeople = await fetchNotLoggedInUsers();
    }
    // For other options, perform local sorting
    else {
      sortedPeople = sortPeople(allPeople, option.value);
    }
    // console.log("SORTED PEOPLE:", sortedPeople)
    setPeople(sortedPeople);
    // console.log('Selected option:', option);
    // console.log('People:', people);
  };

  // const handleDownloadCSV = () => {
  //   // if (downloadExcelRef.current) {
  //   //     downloadExcelRef.current.exportToExcel("People");
  //   // }

  //   const formattedData = allPeople.map((person) => ({
  //     ...person,
  //     created: formatDate(person.created, "year-month-time"),
  //     modified: formatDate(person.modified, "year-month-time"),
  //     last_app_sync_time: formatDate(
  //       person.last_app_sync_time,
  //       "year-month-time"
  //     ),
  //     loginAt: formatDate(person.loginAt, "year-month-time"),
  //     logout_time: formatDate(person.logout_time, "year-month-time"),
  //     Close_Date: formatDate(person.Close_Date, "year-month-time"),
  //   }));
  //   console.log(formattedData, "dataFormateed");

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "ViewUsers");

  //   // Generate and trigger download
  //   XLSX.writeFile(workbook, `People_${format(new Date(), "dd_MM_yyyy")}.xlsx`);
  // };

  const handleDownloadCSV = () => {
    const formattedData = allPeople.map((person) => ({
      Name: person.name || "-",
      "People Code": person.emp_code || "-",
      Designation: person.designation || "-",
      City: person.city || "-",
      "Contact Number": person.mobileNo || "-",
      Email: person.email || "-",
      PlatForm: person.login_device || "-",
      // Device: person.device || "-",
      // "OS Version": person.os_version || "-",
      // "App Version": person.app_version || "-",
      "Date Of Birth": person.dob || "-",
      "Accessed APP?":
        person.login_device === null || person.login_device === ""
          ? "No"
          : "Yes",
      // "Accessed APP?":
      //   person.os_version === null || person.os_version === "" ? "No" : "Yes",
    }));

    console.log(formattedData, "Filtered Data");

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ViewUsers");

    // Generate and trigger download
    XLSX.writeFile(workbook, `People_${format(new Date(), "dd_MM_yyyy")}.xlsx`);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const editItem = (item: People) => {
    navigate(`/people/edit`, { state: { isEdit: true, data: item } });
  };

  const deleteItemById = async (item: People) => {
    try {
      const response = await postDetails(APIList.DELETE_PEOPLE, {
        id: item.id,
      });
      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete user"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("User Deleted Succesfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchPeople();
    } catch (error) {
      console.error("Error deleting user:", error);
      dispatch(showToast("Some error occurred while deleting user."));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const handleBulkDelete = async () => {
    try {
      const ids = Array.from(selectedItems);
      // console.log(ids)
      const response = await postDetails(APIList.DELETE_PEOPLE, { id: ids });
      // console.log(response)

      if (response.status === "Failed") {
        dispatch(showToast("Cannot delete users"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      dispatch(showToast("Users deleted successfully."));
      setTimeout(() => dispatch(hideToast()), 3000);
      setSelectedItems(new Set());
      handleCloseModal();
      fetchPeople();
    } catch (error) {
      console.error("Error deleting users:", error);
      // alert("Some error occurred while deleting users.")
      dispatch(showToast("Some error occurred while deleting users."));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const toggleStatus = async (item: People) => {
    try {
      const newToggle = item.is_Godmod === 1 ? 0 : 1;
      const response = await postDetails(APIList.TOGGLE_GOD_MODE, {
        id: item.id,
        is_Godmod: newToggle,
      });

      if (response.status === "Failed") {
        dispatch(showToast("Cannot update status"));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }

      setPeople((prevData) =>
        prevData.map((row) =>
          row.id === item.id ? { ...row, is_Godmod: newToggle } : row
        )
      );

      dispatch(showToast("Status Successfully Updated."));
      setTimeout(() => dispatch(hideToast()), 3000);
      fetchPeople();
    } catch (error) {
      console.error("Error updating result:", error);
    }
  };

  const columns: TableColumn[] = [
    {
      key: "emp_code",
      label: "Employee Code",
      sortable: true,
      dataType: "string",
    },
    {
      key: "first_name",
      label: "First Name",
      sortable: true,
      dataType: "string",
    },
    {
      key: "last_name",
      label: "Last Name",
      sortable: true,
      dataType: "string",
    },
    { key: "mobileNo", label: "Mobile No.", dataType: "string" },
    { key: "city", label: "City", sortable: true, dataType: "string" },
    {
      key: "is_Godmod",
      label: "Admin (God Mode)",
      dataType: "toggle",
      sortable: true,
    },
  ];

  const handleCheckboxChange = (selectedIds: Set<number>) => {
    // console.log(selectedIds);
    setSelectedItems(selectedIds);
  };

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4">Are you sure you want to delete?</p>
          <div className="d-flex flex-column-reverse flex-md-row align-items-md-center justify-content-md-center gap-3 mb-2">
            <CustomButton theme="yellow" size="md" onClick={handleBulkDelete}>
              Delete
            </CustomButton>
            <CustomButton theme="red" size="md" onClick={handleCloseModal}>
              Cancel
            </CustomButton>
          </div>
        </Modal.Body>
      </Modal>
      {/* <DownloadExcel
                ref={downloadExcelRef}
                excelData={people}
                fileName="People"
                buttonText=""
            /> */}
      <div className="people-action-header d-flex align-items-center mx-2 mb-4">
        <button
          className="people-delete-button"
          onClick={handleShowModal}
          disabled={selectedItems.size === 0}
        >
          <Trash3 />
          <span>Delete</span>
        </button>

        <div className="people-select-container">
          <Select
            options={sortingOptions}
            value={sortingOption}
            styles={customSingleSelectStyles}
            onChange={sortPeopleOption}
            placeholder="Sort By"
            isClearable
            isSearchable={false}
          />
        </div>

        <button className="people-download-excel" onClick={handleDownloadCSV}>
          <span>Download - Excel</span>
          <FileEarmarkFill />
        </button>
      </div>
      <div>
        <CommonTable<People>
          data={people}
          columns={columns}
          onEdit={editItem}
          onDelete={deleteItemById}
          onToggle={toggleStatus}
          pagination={true}
          rowsPerPage={10}
          actions={{
            view: false,
            edit: true,
            delete: true,
            checkbox: true,
            status: false,
            showModal: false,
          }}
          onCheckboxChange={handleCheckboxChange}
        />
      </div>
    </>
  );
};

export default PeopleTable;
